module.exports = __webpack_public_path__ + "static/media/bg_6.04071f88.jpg";